import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import FormItem from '@/components/Common/FormItem/FormItem';
import { FormSectionTitle } from '@/components/Form/FormSectionTitle/FormSectionTitle';
import {
  Button,
  Grid,
  InputAdornment,
  OutlinedInput,
  Stack,
  Typography,
} from '@mui/material';
import { useSalesConditionsViewController } from './SalesConditionsViewController';

export function SalesConditions() {
  const { uiState, actions } = useSalesConditionsViewController();

  return (
    <Stack spacing={'12px'} p={{ xs: '16px', md: '0px' }}>
      <FormSectionTitle title={'Condiciones de compra'} />
      <BasicContainer
        content={
          <Grid container columnSpacing={'20px'} p={'16px'}>
            <Grid item xs={12}>
              <FormItem
                label="Mínimo de compra"
                helperText={uiState.minPurchaseError}
              >
                <OutlinedInput
                  startAdornment={
                    <InputAdornment position="start">$</InputAdornment>
                  }
                  endAdornment={<Typography>MXN</Typography>}
                  value={uiState.minPurchase}
                  onChange={(e) =>
                    actions.onChangedMinSellAmount(e.target.value)
                  }
                  fullWidth
                  error={!!uiState.minPurchaseError}
                />
              </FormItem>
            </Grid>
          </Grid>
        }
        footer={
          <Stack sx={{ flexDirection: 'row-reverse', p: '16px' }} gap={'16px'}>
            <Button
              variant="contained"
              disabled={uiState.saveDisabled}
              onClick={actions.onClickedSave}
            >
              Guardar cambios
            </Button>
            <Button
              variant="contained"
              disabled={uiState.cancelDisabled}
              onClick={actions.onClickedCancel}
            >
              Cancelar
            </Button>
          </Stack>
        }
      />
    </Stack>
  );
}
